"use client";
import t from "./index.es65.js";
import "react";
import "./index.es28.js";
t.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
//# sourceMappingURL=index.es27.js.map
